<template>
  <div class="personal-private-info">
    <div class="personal-private-info__img">
      <img :src="memberAvatar" alt="" />
    </div>
    <div class="personal-private-info__detail">
      <div class="personal-private-info__detail-contact">
        <p class="one-detail">{{ memberName }}</p>
        <div class="gender one-detail">
          <span
            :class="[checkMemberGender ? 'icon-icn_man' : 'icon-icn_woman']"
          ></span>
        </div>
        <div class="phone one-detail">
          {{ memberPhone }}
        </div>
      </div>
      <div class="personal-private-info__detail-status">
        <div class="member-level">會員等級 {{ memberLevelName }}</div>

        <div class="owe-money">欠費 {{ unpaidMoney }}</div>
      </div>
    </div>
    <button class="transparent-btn" @click="attemptReselectMember">
      重新選擇會員
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { fetchMemberOrders } from '@/api/order';
import { fetchMemberById } from '@/api/member';
import { get } from 'lodash';

export default {
  data() {
    return {
      member: {
        level: {}
      },
      orders: []
    };
  },
  computed: {
    ...mapGetters('member', ['isChoose', 'memberId']),
    checkMemberGender() {
      if (this.member.type == 1 && this.member.gender == 0) {
        return false;
      } else if (this.member.type == 1 && this.member.gender == 1) {
        return true;
      }

      return false;
    },
    unpaidMoney() {
      let sum = 0;

      if (this.orders) {
        for (let index = 0; index < this.orders.length; index++) {
          sum += this.orders[index].unpaid_amount;
        }
      }

      return sum;
    },
    memberAvatar() {
      return get(this.member, 'avatar');
    },
    memberName() {
      return get(this.member, 'name');
    },
    memberPhone() {
      return get(this.member, 'phone');
    },
    memberLevelName() {
      return get(this.member, 'level.name', '一般');
    }
  },
  methods: {
    ...mapActions('member', ['reselectMember']),
    attemptReselectMember() {
      this.reselectMember(this.returnChoosePage());
    },
    returnChoosePage() {
      this.$router.push({ name: '銷售' });
    },
    attemptFetchMemberById() {
      fetchMemberById(memberCb => {
        this.member = memberCb;

        this.$emit('setMember', memberCb);
      });
    },
    fetchMemberOrders() {
      fetchMemberOrders({}, orders => {
        this.orders = orders;
      });
    }
  },
  created() {
    if (this.isChoose) {
      this.attemptFetchMemberById();

      this.fetchMemberOrders();
    } else {
      this.returnChoosePage();
    }
  }
};
</script>
